import { isNil, size } from 'lodash';

export const getLocation = (data) => {
  return new Promise((Resolve, reject) => {
    const location = { latitude: 0, longitude: 0 }
    const hostname = window.location.hostname
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      // skip call api if conn is local host for dev
      Resolve(location)
      return
    }
    // eslint-disable-next-line no-undef
    const geocoder = new google.maps.Geocoder()
    const fullAddress = (isNil(data.address) || size(data.address) === 0) ? data.country : data.address

    geocoder.geocode({ 'address': fullAddress }, function (results, status) {
      // eslint-disable-next-line no-undef
      if (status === google.maps.GeocoderStatus.OK) {
        if (results) {
          location.latitude = results[0].geometry.location.lat()
          location.longitude = results[0].geometry.location.lng()
        }
        Resolve(location)
      }
      else {
        console.debug(`Google map getLocation failed: ${status}`)
        Resolve(location)
      }
    });
  })
}